import { fetchWebsocketUrl, refreshWebsocketUrl } from './apiRoutes';

const MAX_RETRIES = 3;

let ws = null;
let intentionalClose = false;
let retryCount = 0;

export async function connectWebSocket(awsConnectContactId, url) {
  url = url || await fetchWebsocketUrl(awsConnectContactId) || await refreshWebsocketUrl(awsConnectContactId);

  if (!url) {
    document.dispatchEvent(new CustomEvent('chatkit.aws.session-expired'));
    return;
  }

  intentionalClose = false;
  const subscribeMessage = JSON.stringify({ topic: 'aws/subscribe', content: { topics: ['aws/chat'] } });
  ws = new WebSocket(url);

  ws.onopen = () => {
    retryCount = 0;
    ws.send(subscribeMessage);
    document.dispatchEvent(new CustomEvent('chatkit.aws.chat-started'));
  };

  ws.onmessage = (event) => {
    const msg = JSON.parse(event.data);
    if (msg.topic !== 'aws/chat') return;

    const content = JSON.parse(msg.content);
    document.dispatchEvent(new CustomEvent('chatkit.aws.websocket-message', { detail: content }));
  };

  ws.onclose = () => {
    if (intentionalClose) return;

    connectWebSocket(awsConnectContactId);
  };

  ws.onerror = async () => {
    intentionalClose = true;
    ws?.close();

    for (retryCount += 1; retryCount < MAX_RETRIES; retryCount += 1) {
      // eslint-disable-next-line no-await-in-loop
      const freshUrl = await refreshWebsocketUrl(awsConnectContactId);
      if (freshUrl) {
        connectWebSocket(awsConnectContactId, freshUrl);
        return;
      }
    }

    document.dispatchEvent(new CustomEvent('chatkit.aws.session-expired'));
  };
}

export function disconnectWebSocket() {
  intentionalClose = true;
  retryCount = 0;
  if (ws) {
    ws.close();
    ws = null;
  }
}
